import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux';

import getStore from './store';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';

const store = getStore();

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>, document.getElementById('root')
);
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js